import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Breadcrumbs, Link, Typography } from '@mui/material';
import { NavigateNext as NavigateNextIcon } from '@mui/icons-material';
import GenericEntityCreator from '../../components/Common/GenericEntityCreator';

const CreateProxy: React.FC = () => {
  const navigate = useNavigate();

  const handleSuccess = (createdEntity: any) => {
    console.log('Proxy created:', createdEntity);
    navigate('/proxies');
  };

  const handleCancel = () => {
    navigate('/proxies');
  };

  return (
    <Box>
      {/* Breadcrumbs */}
      <Breadcrumbs
        separator={<NavigateNextIcon fontSize="small" />}
        sx={{ mb: 3 }}
      >
        <Link
          color="inherit"
          href="/proxies"
          onClick={(e) => {
            e.preventDefault();
            navigate('/proxies');
          }}
        >
          Proxy Management
        </Link>
        <Typography color="text.primary">Create Proxy</Typography>
      </Breadcrumbs>

      {/* Generic Entity Creator */}
      <GenericEntityCreator
        entityType="proxy"
        onSuccess={handleSuccess}
        onCancel={handleCancel}
      />
    </Box>
  );
};

export default CreateProxy;

